import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import config from '../config';

let rumClient: AwsRum | null = null;
let initialized = false;

const initializeAWSRumClient = (): void => {
    if (initialized) return;

    const APPLICATION_ID: string = config?.cloudWatch?.APPLICATION_ID;
    const IDENTITY_POOL_ID: string = config?.cloudWatch?.IDENTITY_POOL_ID;
    const GUEST_ROLE_ARN: string = config?.cloudWatch?.GUEST_ROLE_ARN;

    const awsRumConfig: AwsRumConfig = {
        sessionSampleRate: 1,
        guestRoleArn: GUEST_ROLE_ARN,
        identityPoolId: IDENTITY_POOL_ID,
        endpoint: 'https://dataplane.rum.eu-central-1.amazonaws.com',
        telemetries: ['performance', 'errors', 'http'],
        allowCookies: false,
        enableXRay: false,
    };

    // Verify there is a setup for the environment. Otherwise won't start tracking.
    if (APPLICATION_ID && IDENTITY_POOL_ID) {
        const APPLICATION_VERSION: string = '1.0.0';
        const APPLICATION_REGION: string = 'eu-central-1';

        try {
            rumClient = new AwsRum(
                APPLICATION_ID,
                APPLICATION_VERSION,
                APPLICATION_REGION,
                awsRumConfig,
            );
            initialized = true;
        } catch (error) {
            // Ignore errors thrown during CloudWatch RUM web client initialization
            console.error(error);
        }
    }
};

const trackEvent = (eventId: string, attributes: object): void => {
    if (rumClient) {
        rumClient.recordEvent(eventId, attributes);
    }
};

const trackPage = (pageId: string): void => {
    if (rumClient) {
        rumClient.recordPageView(pageId);
    }
};

export { initializeAWSRumClient, trackPage, trackEvent };
